import React, {
  useEffect,
} from 'react';
import {
  useParams,
} from 'react-router-dom';

import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  Spinner,
  NotFound,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import ProDocuments from './ProDocuments';
import ClientDocuments from './ClientDocuments';

const mapState = state => ({
  isPro: coreSelectors.getProfile('is_pro')(state),
  updateStatus: getStatus(
    state,
    [
      'documents.requests.uploadDocuments.status',
      'assignees.requests.assignDocumentToClient.status',
      'assignees.requests.unAssignDocumentToClient.status',
      'groupAssignments.requests.unAssignDocumentToGroup.status',
      'groupAssignments.requests.assignDocumentToGroup.status',
    ],
    false,
  ),
});

const DocumentsListPage = () => {
  const params = useParams();
  const folderId = Number(params.id);
  const {
    isPro,
    updateStatus,
  } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isPro) {
      dispatch(
        coreActions.requestDocuments(),
      );
    }
  }, [isPro]);

  const Component = isPro ? ProDocuments : ClientDocuments;

  return (
    <Flex fillSpace>
      <Component
        folderId={folderId}
      />

      {updateStatus.failed && (
        <NotFound title="Something went wrong" />
      )}

      {updateStatus.pending && (
        <Spinner over />
      )}
    </Flex>
  );
};

export default DocumentsListPage;
